import { SideNav } from '../common/SideNav';
import { FallbackSideNavFooterLinks } from './FallbackSideNavFooterLinks';
import { FallbackSideNavLinks } from './FallbackSideNavLinks';

export const FallbackSideNav = () => (
  <SideNav SideNavMainComponent={FallbackSideNavLinks} SideNavFooterComponent={FallbackSideNavFooterLinks} />
);
